import toast from "react-hot-toast";
import { api } from "./api";
import { leaveSupportContext } from "../Redux/Actions/contextAction";

const USER_SCOPED_READ = /\/(getscreens|getcontent|getplaylist|getusers|dashboard|countstatsofscreen|countofeachcontent|countofplaylist|getclientscreens|getclientcontents|getclientplaylists)\//;

/**
 * If a user-scoped read is refused while a support context is active (staff
 * role revoked mid-session, or the org deleted), drop the context instead of
 * leaving the operator staring at empty pages.
 */
export function installContextInterceptor(store) {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      const active = store.getState().Context?.activeOrg;
      if (active && (status === 403 || status === 404) && USER_SCOPED_READ.test(url)) {
        toast.error("Du har inte längre tillgång till den här organisationen");
        store.dispatch(leaveSupportContext());
      }
      return Promise.reject(error);
    }
  );
}
